export default {
  path: 'analysis',
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  component: () => import('./ReadPublishAnalysis')
}
